import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import './styles/global.css';
import { RxUserProvider } from './contexts/RxUserContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <RxUserProvider>
        <GlobalStyles />
        <App />
      </RxUserProvider>
    </BrowserRouter>
  </React.StrictMode>
);
